import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../api";
import backgroundImage from '../assets/LOGO.png';

function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            const userData = await login(username, password);
            console.log(userData);
            if (userData.superuser){
                navigate(`/admin/${userData.superuser}`)
            } else{
                navigate(`/mieter/${userData.mieter_id}`); // Redirect after login
            }
        } catch (error) {
            alert("Invalid credentials. Please try again.");
        }
    };

    return (
<div style={{
  backgroundImage: `url(${backgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundSize: 'contain', // or 'cover' depending on preference
  minHeight: '100vh',
  padding: '2rem',
  overflowY: 'auto'
}}>
            <h2>Login</h2>
            <input
  type="text"
  placeholder="Username"
  onChange={(e) => setUsername(e.target.value)}
  style={{ marginRight: "0.5rem" }}
/>

<input
  type="password"
  placeholder="Password"
  onChange={(e) => setPassword(e.target.value)}
  style={{ marginRight: "0.5rem", marginTop: "0.5rem" }}
/>

<button onClick={handleLogin} style={{ marginRight: "0.5rem", marginTop: "0.5rem" }}>
  Login
</button>

            <p>Password vergessen?<Link to={"/password-reset"} >   hier zurücksetzen</Link></p>
        </div>
    );
}

export default LoginPage;
